import { useEffect, useState, type FunctionComponent } from "react";
import { EditCampaignAdminPartial } from "../../../partials/admin/campaigns/edit-campaign.admin.partials";
import { Outlet, useParams } from "react-router-dom";
import type { ICampaign } from "../../../types/models/campaign.models.types";
import { useGetCampaignByIdAdminHttp } from "../../../hooks/http/admin/campaigns/get-campaign-by-id.admin.http";
import Spinner from "../../../components/spinner.components";

export const EditCampaignAdminScreen: FunctionComponent = () => {
	const { campaignId } = useParams();
	const [campaign, setCampaign] = useState<ICampaign | null>(null);
	const { execute } = useGetCampaignByIdAdminHttp();

	if (!campaignId) {
		throw new Error("campaign id not found");
	}

	// biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
	useEffect(() => {
		getCampaign(campaignId);
	}, []);

	async function getCampaign(campaignId: string) {
		const response = await execute({
			body: null,
			pathParams: { id: campaignId },
		});
		if (!response.success) {
			throw new Error(response.error.message);
		}
		setCampaign(response.data.campaign);
	}

	if (campaign == null) {
		return (
			<div className="flex flex-1 justify-center items-center h-screen">
				<Spinner />
			</div>
		);
	}

	return (
		<div className="w-full">
			<EditCampaignAdminPartial campaign={campaign} />
			<Outlet />
		</div>
	);
};
